import * as React from "react";
// import SvgIcon from "../CustomeComponents/SvgIcon";
import SvgIcon from './SvgIcon';
import clsx from "clsx";

const PageBar = ({ children, className, ...others }) => {

    // const runAction = () => {
    //     console.log('Export to Excel OR Pdf')
    //     alert("In progress 😎");
    // }

    return (
        <div className={clsx('page-bar', className)}>
            <div className="flex-1">
                {children}
            </div>

            {/* <a onClick={() => runAction()}>
                <SvgIcon icon={"file-exe"} />
            </a> */}
        </div>
    );
}

export default PageBar;
